export default __webpack_public_path__ + "static/media/supersonic.ce19bb3c.svg";